import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleSummaryReportByInternshipLocation } from 'domain/usecases';

export class RemoteHandleSummaryReportByInternshipLocation
  implements HandleSummaryReportByInternshipLocation
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleSummaryReportByInternshipLocation.Result>,
  ) {}

  async execute(
    params: HandleSummaryReportByInternshipLocation.Params,
  ): Promise<HandleSummaryReportByInternshipLocation.Result> {
    const { type } = params;
    const requestUrl = generateUrl(this.url + '/' + type, params as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: params.type === '2' ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
